<template>
  <b-modal
    :id="id"
    headerClass="p-2 mt-2 border-bottom-0"
    footerClass="p-2 border-top-0"
    body-class="pt-0 text-secondary"
    centered
    @ok="$emit('handleOk')"
    @cancel="$emit('cancel')"
    @hide="$emit('cancel')"
    ><p v-if="message === '' && $route.name !== 'form-create'">
      Are you sure you want to cancel? Please make sure to save your work before cancelling or risk
      losing all your progress.
    </p>
    <p v-if="message === '' && $route.name === 'form-create'">
      Are you sure you want to discard? There will be no way to retreive your work if you do.
    </p>
    <p v-else>{{ message }}</p>
    <template #modal-header="{ hide }">
      <p class="modal-header-text font-weight-bold pb-0 mb-0 pl-1">Warning!</p>
      <b-button variant="link-dark" class="float-right" @click="hide()"
        ><b-icon icon="x"></b-icon
      ></b-button>
    </template>
    <template #modal-footer="{ ok, cancel }">
      <b-button :disabled="busy" pill variant="primary" @click="cancel()">
        Continue editing
      </b-button>
      <b-button
        :disabled="busy"
        pill
        variant="outline-primary"
        @click="$emit('modalSaveDraft')"
        v-if="!$route.name === 'forms'"
      >
        Save Draft
      </b-button>
      <b-button :disabled="busy" pill variant="link" @click="ok()">Don't save</b-button>
    </template>
  </b-modal>
</template>
<script>
  export default {
    props: ['busy', 'id', 'message'],
  };
</script>
